import React from 'react';
import './Ingredients.css';

const Ingredients = () => {
    const ingredients = [
        {
            title: "Chocolat de Dégustation",
            description: "Des crus d'exception sélectionnés pour leur intensité aromatique et leur finesse inégalée.",
            image: "/images/ingredient_chocolat.jpg"
        },
        {
            title: "Beurre de Baratte",
            description: "Un beurre de tradition, baratté à l'ancienne pour un feuilletage d'une gourmandise absolue.",
            image: "/images/ingredient_beurre.jpg"
        },
        {
            title: "Fruits de Saison",
            description: "Cueillis à maturité chez nos producteurs locaux pour une fraîcheur et un goût authentique.",
            image: "/images/ingredient_fruits.jpg"
        }
    ];

    return (
        <section className="ingredients-section">
            <div className="container">
                <div className="section-header text-center">
                    <span className="section-subtitle">L'Excellence du Goût</span>
                    <h2 className="section-title">Nos Ingrédients d'Exception</h2>
                    <div className="divider"></div>
                </div>

                <div className="ingredients-grid">
                    {ingredients.map((item, index) => (
                        <div key={index} className="ingredient-card">
                            <div className="ingredient-image">
                                <img src={item.image} alt={item.title} />
                                <div className="ingredient-overlay"></div>
                            </div>
                            <div className="ingredient-info">
                                <h4>{item.title}</h4>
                                <p>{item.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Ingredients;
